import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../../styles/colors';
import { truncateTextStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		padding: '0 20px',
		minHeight: 48,
	},
	avatar: {
		width: 40,
		height: 40,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#fff',
		fontWeight: 600,
		fontSize: 16,
		flexShrink: 0,
	},
	nameRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	contactName: {
		...truncateTextStyle,
		fontSize: 18,
		maxWidth: '95%',
	},
	phoneNumber: {
		fontSize: 13,
		color: '#888',
	},
	editButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: 2,
		color: '#999',
		fontSize: 14,
		display: 'flex',
		alignItems: 'center',
		':hover': {
			color: '#666',
		},
	},
	addContactLink: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		fontSize: 13,
		fontWeight: 500,
		padding: 0,
		textDecoration: 'underline',
	},
	editContainer: {
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 10,
		padding: '12px 20px',
		width: '100%',
	},
	editHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	editLabel: {
		fontSize: 13,
		fontWeight: 600,
		color: '#666',
		textTransform: 'uppercase' as const,
		letterSpacing: 0.5,
	},
	closeButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		color: '#999',
		fontSize: 18,
		lineHeight: '1',
		':hover': {
			color: '#666',
		},
	},
	searchInput: {
		width: '100%',
		boxSizing: 'border-box' as const,
		padding: '8px 12px',
		border: '1px solid #ddd',
		borderRadius: 6,
		fontSize: 14,
		outline: 'none',
	},
	resultsList: {
		border: '1px solid #eee',
		borderRadius: 6,
		maxHeight: 180,
		overflowY: 'auto' as const,
	},
	resultItem: {
		padding: '8px 12px',
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		cursor: 'pointer',
		width: '100%',
		background: 'none',
		border: 'none',
		textAlign: 'left' as const,
		':hover': {
			background: '#f5f8ff',
		},
	},
	resultAvatar: {
		width: 28,
		height: 28,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#fff',
		fontSize: 11,
		fontWeight: 600,
		flexShrink: 0,
	},
	resultName: {
		fontSize: 13,
		fontWeight: 500,
	},
	resultEmail: {
		fontSize: 11,
		color: '#888',
	},
	removeLink: {
		background: 'none',
		border: 'none',
		color: '#d9534f',
		cursor: 'pointer',
		fontSize: 13,
		fontWeight: 500,
		padding: '8px 0 0 0',
		borderTop: '1px solid #eee',
		textAlign: 'left' as const,
	},
	noResults: {
		padding: 12,
		fontSize: 13,
		color: '#888',
		textAlign: 'center' as const,
	},
	saving: {
		opacity: 0.6,
		pointerEvents: 'none' as const,
	},
});
